import React, { useEffect, useState } from 'react';
import { TEXT_DEF } from '../../../constant/text';
import { Button } from 'antd';
import ModalCommon from '../../../components/Modal';
import API, { ADMIN_BAUCUA } from '../../../network/api';
import { RIGHTS } from '../../../constant/rights';
import { hasRight } from '../../../components/until/right';
import CustomInputNumber from '../../../components/common/CustomInputNumber';
import RenderSwitch from '../../../components/common/Switch';

const BauCuaSetting = () => {
  const [isMaintenance, setIsMaintenance] = useState();
  const [isUseBonus, setIsUseBonusOriginal] = useState()
  const [dataUp, setDataUp] = useState();
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [valueToUpdate, setValueToUpdate] = useState({});
  const labels = {
    bau: 'Bầu',
    cua: 'Cua',
    tom: 'Tôm',
    ca: 'Cá',
    nai: 'Nai',
    ga: 'Gà',
    bau_bau: 'Bầu - Bầu',
    cua_cua: 'Cua - Cua',
    tom_tom: 'Tôm - Tôm',
    ca_ca: 'Cá - Cá',
    nai_nai: 'Nai - Nai',
    ga_ga: 'Gà - Gà',
    bau_bau_bau: 'Bầu - Bầu - Bầu',
    cua_cua_cua: 'Cua - Cua - Cua',
    tom_tom_tom: 'Tôm - Tôm - Tôm',
    ca_ca_ca: 'Cá - Cá - Cá',
    nai_nai_nai: 'Nai - Nai - Nai',
    ga_ga_ga: 'Gà - Gà - Gà',
    all: '3x Bất Kỳ',
    ratesWin: 'Phần trăm lợi nhuận',
    ratesWinTest: 'Phần trăm lợi nhuận user chơi thử',
    maxRateBookmakerLose: 'Tỉ lệ thua cho phép nhà cái',
    percentBonus: 'Tỉ lệ bonus',
    maxBookmakerLoseRate: 'Tỉ lệ mặc định tối đa nhà cái có thể thua, chưa cộng dồn',
    maxBookmakerLoserRateLimit: 'Tỉ lệ thua tối đa của nhà cái sau khi cộng dồn',
    whenSoloAdded: 'Cộng vào tỉ lệ thua nhà cái khi có 1 người chơi',
    whenBookmakerWinUpAdded: 'Cộng vào tỉ lệ thua nhà cái khi nhà cái thắng liên tiếp quá 2 lần',
    whenBookmakerBigWin: 'Cộng vào tỉ lệ thua của nhà cái khi turn trước nhà cái thắng lớn',
    conditionForUserWinByPreBookmakerWin: 'Điều kiện: tỉ lệ thắng của nhà cái quá cao (trận trước)',
  };

  useEffect(() => {
    getDataXocDia();
  }, []);

  const getDataXocDia = async () => {
    const response = await API.get(`${ADMIN_BAUCUA}/getConfig`);
    const resultGame = response.data?.data?.result;
    setData(resultGame);
  };


  const showConfirm = (key) => {
    let params;
    const id = data?.find((x) => x.key === key)?.id;
    switch (key) {
      case 'isMaintenance':
        params = {
          key: 'isMaintenance',
          value: isMaintenance.toString(),
        };
        break;
      case 'isUseBonus':
        params = {
          key: 'isUseBonus',
          value: isUseBonus.toString(),
        };
        break;
      case 'bau':
        params = {
          key: 'bau',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'cua':
        params = {
          key: 'cua',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'tom':
        params = {
          key: 'tom',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ca':
        params = {
          key: 'ca',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'nai':
        params = {
          key: 'nai',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ga':
        params = {
          key: 'ga',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'bau_bau':
        params = {
          key: 'bau_bau',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'cua_cua':
        params = {
          key: 'cua_cua',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'tom_tom':
        params = {
          key: 'tom_tom',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ca_ca':
        params = {
          key: 'ca_ca',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'nai_nai':
        params = {
          key: 'nai_nai',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ga_ga':
        params = {
          key: 'ga_ga',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'bau_bau_bau':
        params = {
          key: 'bau_bau_bau',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'cua_cua_cua':
        params = {
          key: 'cua_cua_cua',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'tom_tom_tom':
        params = {
          key: 'tom_tom_tom',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ca_ca_ca':
        params = {
          key: 'ca_ca_ca',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'nai_nai_nai':
        params = {
          key: 'nai_nai_nai',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ga_ga_ga':
        params = {
          key: 'ga_ga_ga',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'all':
        params = {
          key: 'all',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ratesWin':
        params = {
          key: 'ratesWin',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'ratesWinTest':
        params = {
          key: 'ratesWinTest',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'maxRateBookmakerLose':
        params = {
          key: 'maxRateBookmakerLose',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'maxBookmakerLoseRate':
        params = {
          key: 'maxBookmakerLoseRate',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'maxBookmakerLoserRateLimit':
        params = {
          key: 'maxBookmakerLoserRateLimit',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'whenSoloAdded':
        params = {
          key: 'whenSoloAdded',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'whenBookmakerWinUpAdded':
        params = {
          key: 'whenBookmakerWinUpAdded',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'whenBookmakerBigWin':
        params = {
          key: 'whenBookmakerBigWin',
          value: valueToUpdate[key].toString(),
        };
        break;
      case 'conditionForUserWinByPreBookmakerWin':
        params = {
          key: 'conditionForUserWinByPreBookmakerWin',
          value: valueToUpdate[key].toString(),
        };
        break;
      default:
        break;
    }

    const dataReq = {
      id: id,
      params: params,
    };
    setDataUp(dataReq);
    setIsShowModalConfirm(true);
  };

  const handleChangeSwitch = (e, key) => {
    if (key === "isMaintenance") {
      setIsMaintenance(e);
    } else if (key === "isUseBonus") {
      setIsUseBonusOriginal(e);
    }
  };

  const onRequest = async () => {
    if (!dataUp) return;
    await API.patch(`${ADMIN_BAUCUA}/updateConfig/${dataUp?.id}`, dataUp?.params)
      .then((response) => {
        const result = response.data?.data;
        if (result?.code === 20004) {
          setLoading(true);
          setIsShowModalConfirm(false);
          setIsShowModalSuccess(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetKey = (value) => {
    showConfirm(value);
  };

  const handleInputChange = (key, newValue) => {
    setValueToUpdate((prev) => ({ ...prev, [key]: Number(newValue) }));
  };

  const renderInputFields = () => {
    if (!data || data.length === 0) return;

    const keysToFilter = [
      'bau', 'cua', 'tom', 'ca', 'nai', 'ga',
      'bau_bau', 'cua_cua', 'tom_tom', 'ca_ca', 'nai_nai', 'ga_ga',
      'bau_bau_bau', 'cua_cua_cua', 'tom_tom_tom', 'ca_ca_ca', 'nai_nai_nai', 'ga_ga_ga',
      'all', 'ratesWin', 'ratesWinTest', 'maxRateBookmakerLose', 'percentBonus', 
      'maxBookmakerLoseRate','maxBookmakerLoserRateLimit', 'whenSoloAdded', 'whenBookmakerWinUpAdded',
      'whenBookmakerBigWin', 'conditionForUserWinByPreBookmakerWin',
    ];
    const filteredData = data.filter((item) => keysToFilter.includes(item.key));

    return (
      <>
        {filteredData.length > 0 &&
          filteredData?.map((item, index) => (
            <>
              <div className="col-12 flex" key={index}>
                <div className="col-3 text-left">{labels[item?.key] || item.key}</div>
                <div className="col-6">
                  <CustomInputNumber min={-1} max={9999} step={0.01} value={item?.value} onChange={(e) => handleInputChange(item.key, e)} />
                </div>
                {hasRight([RIGHTS.EditSettingOriginals]) ? (
                  <div className="col-3 text-left">
                    <Button
                      type="primary"
                      onClick={() => {
                        handleGetKey(item?.key);
                      }}
                    >
                      {TEXT_DEF.text0016}
                    </Button>
                  </div>
                ) : null}
              </div>
              <div style={{ margin: '10px 0px' }} />
            </>
          ))}
      </>
    );
  };

  return (
    <>
      {data ? (
        <div className="col-12 flex-col" style={{ display: 'flex', marginTop: 30, alignItems: 'center' }}>
          <RenderSwitch data={data} labels={labels} handleChangeSwitch={handleChangeSwitch} hasRight={hasRight} handleGetKey={handleGetKey} />
          <div style={{ margin: '10px 0px' }} />
          {renderInputFields()}
          <div style={{ margin: '10px 0px' }} />
        </div>
      ) : null}
      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0071}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0072}
          actionNext={onRequest}
          close={() => {
            setIsShowModalConfirm(false);
            setDataUp(undefined);
          }}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0073}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => {
            setIsShowModalSuccess(false);
          }}
          close={() => {
            setIsShowModalSuccess(false);
          }}
        />
      )}
    </>
  );
};

export default BauCuaSetting;
